<template>
  <div class="Reg">
    <H5SignPageHeader v-if="mobileFlag" />
    <div class="RegDiv">
      <div class="RegLeft">
        <div class="RegTitle">
          <div class="registerTitleWrapper">
            <span class="registerTitle">{{ $t("Register_Title") }}</span>
            <!-- PC语言切换 -->
            <LangSelect v-if="!mobileFlag" />
          </div>
          <!-- 已有账号 -->
          <span class="RegReturn">
            {{ $t("Register_Tips1") }}
            <b @click="goLogin()">{{ $t("Common_Login") }}</b>
          </span>
        </div>
        <!-- 注册表单 -->
        <el-form
          class="loginForm"
          ref="RegForm"
          label-position="top"
          :rules="rules"
          label-width="80px"
          :model="RegForm"
        >
          <el-form-item :label="$t('Common_Email')" prop="email">
            <el-input
              type="text"
              v-model="RegForm.email"
              maxlength="250"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Common_Phone')" prop="phone">
            <el-input v-model="RegForm.phone" maxlength="250"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Common_UserName')" prop="userName">
            <el-input
              type="text"
              v-model="RegForm.userName"
              maxlength="250"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Common_Password')" prop="password">
            <el-input
              v-model="RegForm.password"
              autocomplete="off"
              type="password"
              show-password
              maxlength="250"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Common_ConfirmPassword')" prop="confirm">
            <el-input
              v-model="RegForm.confirm"
              autocomplete="off"
              type="password"
              show-password
              maxlength="250"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Common_Code')" prop="verifyCode">
            <el-input
              v-model="RegForm.verifyCode"
              autocomplete="off"
              maxlength="6"
            ></el-input>
            <el-button
              class="sendCodeBtn"
              v-loading.fullscreen.lock="fullscreenLoading"
              @click="sendCode"
              :disabled="dis"
            >
              <span v-if="show">{{ $t("Common_SendCode") }}</span>
              <span v-else>{{
                $t("Common_RetrySendCode") + "(" + count + "s)"
              }}</span>
            </el-button>
          </el-form-item>
        </el-form>
        <el-button
          class="RegBtn"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="Reg"
          >{{ $t("Common_Submit") }}</el-button
        >
      </div>
    </div>
    <div class="loginBottom">{{ $t("Login_BottomTips") }}</div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LangSelect from "@/components/common/LangSelect.vue";
import H5SignPageHeader from "./Sign/components/H5SignPageHeader.vue";

export default {
  name: "Reg",
  components: {
    LangSelect,
    H5SignPageHeader,
  },
  computed: {
    ...mapState(["mobileFlag", "lang"]),
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("Common_Valid_PasswordNotNull")));
      } else {
        var pwdRegex = new RegExp(
          "(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,16}"
        );
        if (!pwdRegex.test(value)) {
          callback(new Error(this.$t("SettingPassword_MatchMessage")));
        } else if (this.RegForm.confirm !== "") {
          this.$refs.RegForm.validateField("confirm");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("Common_Valid_ConfirmPasswordNotNull")));
      } else if (value !== this.RegForm.password) {
        callback(new Error(this.$t("Common_Valid_ConfirmPasswordNotcorrect")));
      } else {
        callback();
      }
    };
    return {
      RegForm: {
        email: "",
        phone: "",
        userName: "",
        password: "",
        confirm: "",
        verifyCode: "",
      },
      fullscreenLoading: false,
      show: true,
      count: 60,
      dis: false,
      isGrey: false, //按钮样式
      timer: null, //设置计时器,
      rules: {
        email: [
          {
            required: true,
            message: this.$t("Common_Valid_EmailNotNull"),
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$t("Common_Valid_EmailMatchError"),
            trigger: ["blur", "change"],
          },
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        confirm: [{ validator: validatePass2, trigger: "blur" }],
        verifyCode: [
          {
            required: true,
            message: this.$t("Common_Valid_VerifyCodeNotNull"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    sendCode() {
      this.$refs.RegForm.validateField("email", (valid) => {
        if (!valid) {
          this.fullscreenLoading = true;

          this.$axios
            .get("/Api/Login/SendCode?email=" + this.RegForm.email)
            .then((res) => {
              let dt = res.data;
              if (dt.isSuccess) {
                this.$notify.success({
                  title: this.$t("Common_Prompt"),
                  message: this.$t("Common_Success"),
                });
                this.code60(60);
              } else {
                this.$notify.error({
                  title: this.$t("Common_Prompt"),
                  message: dt.result,
                });
              }
            })
            .finally(() => {
              this.fullscreenLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    code60(time) {
      let TIME_COUNT = time;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.dis = true;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.dis = false;
            this.isGrey = false;
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    Reg() {
      this.$refs.RegForm.validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          let params = {
            confirm: this.Rsa.encrypt(this.RegForm.confirm.trim()),
            email: this.RegForm.email.trim(),
            password: this.Rsa.encrypt(this.RegForm.password.trim()),
            phone: this.RegForm.phone.trim(),
            userName: this.RegForm.userName.trim(),
            verifyCode: this.RegForm.verifyCode.trim(),
          };
          this.$axios
            .post("/Api/Login/Reigst", params)
            .then((res) => {
              let dt = res.data;
              if (dt.isSuccess) {
                this.$notify.success({
                  title: this.$t("Common_Prompt"),
                  message: this.$t("Common_Success"),
                });
                this.$router.push({ path: "/Login" });
              } else {
                this.$notify.error({
                  title: this.$t("Common_Prompt"),
                  message: dt.result,
                });
              }
            })
            .finally(() => {
              this.fullscreenLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goLogin() {
      this.$router.push({ path: "/Login" });
    },
  },
};
</script>
<style scoped lang="less">
.Reg {
  background: #d5eafd;
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: scroll;
  .RegDiv {
    margin: 0 auto 20px auto;
    max-width: 520px;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 80px;

    .RegLeft {
      width: 100%;
      background: #fff;
      padding: 20px 40px;
      .RegTitle {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        .RegReturn {
          margin-top: 10px;
          color: #a8a7a7;
          b {
            font-weight: 500;
            color: #4d71ff;
            cursor: pointer;
          }
        }
      }
      .loginForm {
        margin-top: 20px;
        .sendCodeBtn {
          border-radius: 4px;
          background: #4d71ff;
          padding: 8px 13px;
          color: #fff;
          font-family: "PingFangSC-Medium";
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 14px;
          position: absolute;
          right: 16px;
          top: 8px;
        }
      }
      .RegTips {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 20px;
        span {
          color: #000;
          font-family: "PingFangSC-Medium";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
        }
        b {
          color: #4d71ff;
          text-align: right;
          font-family: "PingFangSC-Medium";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-decoration: none;
          cursor: pointer;
        }
      }
    }
    .RegRight {
      width: 50%;
      img {
        height: 100%;
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;
      }
    }
    .RegBtn {
      border-radius: 4px;
      background: #0f1845;
      display: flex;
      width: 440px;
      padding: 10px 30px;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-family: "PingFangSC-Medium";
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin-top: 40px;
    }
  }
  .loginBottom {
    color: #0f1845;
    font-family: "PingFangSC-Medium";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 1200px;
    margin: 50px auto 0 auto;
    padding-bottom: 30px;
    opacity: 0.3;
  }
}

.registerTitleWrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .registerTitle {
    color: #000;
    font-family: "PingFangSC-Semibold";
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }
}

@media screen and (max-width: 767px) {
  .Reg {
    background: #fff;
    .RegDiv {
      position: relative;
      display: flex;
      flex-direction: column;
      top: 0;
      .RegLeft {
        width: calc(100% - 40px);
        padding: 30px 20px;
        .RegTitle {
          .registerTitle {
            font-size: 18px;
          }
          .RegForm {
            margin-top: 30px;
          }
        }
        .RegTips {
          span,
          b {
            font-size: 14px;
          }
        }
      }
      .RegBtn {
        width: 100%;
        background-color: #4d71ff;
        font-size: 14px;
      }

      .RegRight {
        display: none;
      }
    }
    .loginBottom {
      padding: 20px 20px 35px 20px;
      bottom: 0;
      background: #f4f4f4;
      color: #0f1845;
      font-size: 12px;
      position: relative;
    }
  }
}
</style>
